import './index.css.proxy.js';
/* src/routes/index.svelte generated by Svelte v3.29.4 */
import {
	SvelteComponent,
	attr,
	children,
	claim_component,
	claim_element,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { initClient } from "../../web_modules/@urql/svelte.js";
import WardProgram from "../components/WardProgram.js";
import { onMount } from "../../web_modules/svelte.js";

function create_fragment(ctx) {
	let main;
	let wardprogram;
	let current;
	wardprogram = new WardProgram({});

	return {
		c() {
			main = element("main");
			create_component(wardprogram.$$.fragment);
			this.h();
		},
		l(nodes) {
			main = claim_element(nodes, "MAIN", { class: true });
			var main_nodes = children(main);
			claim_component(wardprogram.$$.fragment, main_nodes);
			main_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(main, "class", "svelte-b1kwhu");
		},
		m(target, anchor) {
			insert(target, main, anchor);
			mount_component(wardprogram, main, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(wardprogram.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wardprogram.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(main);
			destroy_component(wardprogram);
		}
	};
}

function instance($$self) {
	initClient({
		url: "https://85alonsv.api.sanity.io/v1/graphql/production/default"
	});

	return [];
}

class Routes extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Routes;
//# sourceMappingURL=index.js.map
